import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { Accounts } from '../../../enum';
import { ArDocModalWithToggle } from '../../../../shared';
import { useAccountPositionsHistoryArDocHasFileName, useAccountPositionsHistoryArDocId } from '../../hooks';

export const AccountsPositionsHistoryArDocFileName = (props: {
  size?: string | number | undefined,
  transform?: ouiStyle.InStyle['transform'],
  color?: ouiStyle.Constants.Colors,
}) => {
  const {
    size,
    transform,
    color,
  } = props;
  const {
    data: hasFileName,
    isLoading,
  } = useAccountPositionsHistoryArDocHasFileName();
  const { data: arDocId } = useAccountPositionsHistoryArDocId();
  return (
    <ArDocModalWithToggle
      service={Accounts.PositionsHistory}
      hasFileName={hasFileName}
      isLoading={isLoading}
      arDocId={arDocId}
      size={size}
      transform={transform}
      color={color}
    />
  );
};
